import React from "react";

const SettlementSummary = ({ settlement }) => {

    return (

        <div className="settlement-summary">

            <h3>Settlement Summary</h3>

            <div className="summary-grid">

                <div className="summary-item">

                    <h4>Total Revenue</h4>

                    <h2>₹{settlement.totalRevenue}</h2>

                </div>

                <div className="summary-item">

                    <h4>Commission</h4>

                    <h2>₹{settlement.commission}</h2>

                </div>

                <div className="summary-item">

                    <h4>Taxes</h4>

                    <h2>₹{settlement.taxes}</h2>

                </div>

                <div className="summary-item">

                    <h4>Final Payable</h4>

                    <h2>₹{settlement.payableAmount}</h2>

                </div>

            </div>

        </div>

    );

};

export default SettlementSummary;